import { render } from "./DownloadIcon.vue?vue&type=template&id=0fdcc7e6"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__